import EDC from '../../../shared/globals';

const ICON_NEEDED_HEIGHT = 250;

/**
 *
 */
EDC.Games.CategorizationSimpleFrame.TaskItem = function (scene) {
  this.scene = scene;
  this.container = null;
  this.bg = null;
  this.icon = null;
  this.itemName = null;
  return this;
};
/**
 *
 */
EDC.Games.CategorizationSimpleFrame.TaskItem.prototype.create = function () {
  this.container = this.scene.add.container(0, 0);
  this.bg = this.scene.add.sprite(0, 0, 'target-frame');
  this.bg.x += this.bg.width / 2;
  this.bg.y += this.bg.height / 2;
  this.container.add(this.bg);

  const font = {
    font: `${this.scene.gameConfig.labelSize} ${this.scene.gameConfig.font}`,
  };
  this.itemName = this.scene.add
    .text(this.bg.width / 2 + 135, this.bg.height / 2 - 20, 'TEST TEXT', font)
    .setOrigin(0.5, 0.5);
  this.container.add(this.itemName);

  this.container.x = this.scene.game.config.width / 2 - this.bg.width / 2;
  this.container.y = 50;
  return this;
};
/**
 *
 */
EDC.Games.CategorizationSimpleFrame.TaskItem.prototype.update = function (text, spriteName) {
  if (this.icon) {
    this.icon.destroy();
  }
  this.icon = this.scene.add.sprite(0, this.bg.height / 2 - 20, spriteName);
  const neededScale = ICON_NEEDED_HEIGHT / this.icon.height;

  this.icon.setScale(neededScale);

  this.icon.x += this.icon.displayWidth;

  this.container.add(this.icon);

  if (this.itemName) this.itemName.setText(text);
};

EDC.Games.CategorizationSimpleFrame.TaskItem.prototype.deleteObject = function () {
  this.container.destroy();
};

export default EDC.Games.CategorizationSimpleFrame.TaskItem;
